"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgConditioner = function SvgConditioner(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.545 10.505h19.02m-.533 1.486H2.97m14.697-7.507v3.793m-1.619-3.04 3.315 2.243m0-2.243L16.048 7.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.508 13.607c.136 2.558-.919 5.246-3.163 8.063m10.011-8.063c-.136 2.558.919 5.246 3.164 8.063m-6.452-8.3v8.467",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.932 13.5H5.545a3 3 0 0 1-3-3V4.551a2 2 0 0 1 2-2h15.02a2 2 0 0 1 2 2V10.5a3 3 0 0 1-3 3h-1.374"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgConditioner);
var _default = exports["default"] = Memo;